/* eslint-disable rulesdir/eslint-no-index-tsx -- kept as index.tsx to match the folder import used across the app */
import { ErrorPage, SharedComponentsProvider } from '@sortlist-frontend/shared-components';
import { Trans, useTranslation } from '@sortlist-frontend/translation/ssr';

type FallbackProps = {
  error: unknown;
  componentStack: string | null;
  eventId: string | null;
};

// The error boundary sits above SharedComponentsProvider, so we re-provide it here to let the
// shared ErrorPage resolve its `base:` translations. DesignSystemProvider already wraps the app
// (in _app.tsx), so ErrorPage's design-system components render correctly.
const ErrorBoundaryFallback = (props: FallbackProps & { testId: string }) => {
  const { error, eventId, testId } = props;
  const { t, i18n } = useTranslation(['common']);

  return (
    <div data-testid={testId} className="h-screen w-full">
      <SharedComponentsProvider t={t} Trans={Trans} locale={i18n.language}>
        <ErrorPage error={error instanceof Error ? error : null} sentryErrorId={eventId ?? undefined} />
      </SharedComponentsProvider>
    </div>
  );
};

export const GlobalErrorFallback = (props: FallbackProps) => (
  <ErrorBoundaryFallback {...props} testId="global-error-boundary-container" />
);

export const ErrorFallback = (props: FallbackProps) => (
  <ErrorBoundaryFallback {...props} testId="error-boundary-container" />
);
